import { useTranslations } from "use-intl";
import type { MatchLabels } from "@/types/review";

/** The words of a matcher's item, its target and its ledger, in the active language. */
export interface MatchWords {
  item: string;
  target: string;
  /** The target as a plain name, for a row title. */
  targetName: string;
  ledger: string;
}

/** The backend names a matcher's words in English; the matchers the catalog knows are keyed by their `item`. */
const KNOWN_MATCHERS: Record<string, "taxSie"> = { "tax account row": "taxSie" };

/** A matcher the catalog does not know (or none at all) is shown in the backend's own words, or in neutral ones. */
export function useMatchLabels(labels: MatchLabels | undefined): MatchWords {
  const t = useTranslations("consultantReview.match.words");
  if (!labels) return words(t, "generic");
  const known = KNOWN_MATCHERS[labels.item];
  if (known) return words(t, known);
  return { item: labels.item, target: labels.target, targetName: labels.target, ledger: labels.ledger };
}

function words(t: ReturnType<typeof useTranslations<"consultantReview.match.words">>, matcher: "generic" | "taxSie"): MatchWords {
  return {
    item: t(`${matcher}.item`),
    target: t(`${matcher}.target`),
    targetName: t(`${matcher}.targetName`),
    ledger: t(`${matcher}.ledger`),
  };
}
